const Types = {
  TRANSACTIONS__GET_TRANSACTIONS: 'TRANSACTIONS__GET_TRANSACTIONS',
  TRANSACTIONS__MANAGE_TRANSACTIONS: 'TRANSACTIONS__MANAGE_TRANSACTIONS',
};

export default Types;
